export const anticipationDrawer = {
	title: "Solicitar Anticipación y Pago de Boleta",
	titleAnticipation: "Solicitar Anticipación",
	titleBilletPayment: "Solicitar Pago de Boleta",
	anticipationValue: "Valor de la anticipación",
	accountData: "Información de la cuenta",
	summary: "Revisión de los datos",
	warningBanner:
		"Solicitudes realizadas después de las 10h30 (horario de Brasilia) solo serán atendidas al día siguiente.",
	warningAccountChoice:
		"Se cobrará una tarifa de {{value}} para anticipación en cuentas de terceros.",
	formStatusError: "No fue posible completar la solicitud.",
	formStatusSuccess: "¡Anticipación solicitada con éxito!",
	form: {
		selectAccountPlaceholder: "Escriba o seleccione la cuenta",
		liquidValue: "Valor neto",
		liquidValuePlaceholder: "Ingrese aquí el valor neto",
		totalValue: "Total a anticipar",
		totalValueTooltip: "El valor neto más la tarifa de anticipación.",
		reason: "Motivo de la solicitud",
		reasonPlaceholder: "Ingrese aquí el motivo para la anticipación",
		accountType: "Transferir a",
		accountTypes: {
			default: "Cuenta predeterminada",
			existing: "Cuenta registrada",
			new: "Nueva cuenta",
			tooltip: "Aquella establecida en contrato",
		},
		shouldSaveForFutureRequests: "Guardar cuenta para transacciones futuras",
		bankData: "Datos bancarios",
		name: "Identificador de la cuenta",
		summaryTitle: "Revisión de valores",
		summaryReason: "Motivo",
		summaryValue: "Valor solicitado",
		summaryAnticipationFee: "Tarifa de anticipación",
		summaryLiquidValue: "Valor neto solicitado",
		summaryThirdPartyFee: "Tarifa de anticipación para terceros",
		summaryTotal: "Valor bruto a anticipar",
		withdrawAll: "Anticipar todo valor disponible",
	},
};
